import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { Skeleton } from '@/components/ui/skeleton'
import { useCrawlExtractions } from '../hooks/useCrawls'

export function ExtractionsTab({ crawlId }: { crawlId: string }) {
  const { data, isLoading } = useCrawlExtractions(crawlId, true)

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    )
  }

  if (!data || data.rules.length === 0) {
    return (
      <Card>
        <CardContent className="py-8 text-center text-muted-foreground">
          No custom extraction rules were configured for this crawl.
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {data.results.map((result) => (
          <Card key={result.label}>
            <CardContent className="p-4 text-center">
              <p className="text-2xl font-bold">{result.totalMatches}</p>
              <p className="text-xs text-muted-foreground">{result.label}</p>
              <p className="text-xs text-muted-foreground mt-0.5">
                {result.pagesWithMatches} {result.pagesWithMatches === 1 ? 'page' : 'pages'}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>

      {data.results.map((result) => (
        <Card key={result.label}>
          <CardHeader className="pb-3">
            <CardTitle className="text-base flex items-center gap-2">
              {result.label}
              <Badge variant="outline" className="font-normal">
                {result.totalMatches} match{result.totalMatches !== 1 ? 'es' : ''}
              </Badge>
            </CardTitle>
            <CardDescription className="font-mono text-xs">{result.selector}</CardDescription>
          </CardHeader>
          <CardContent>
            {result.pages.length === 0 ? (
              <p className="text-sm text-muted-foreground">No matches found</p>
            ) : (
              <div className="space-y-3 text-sm">
                {result.pages.map((page) => (
                  <div key={page.url} className="space-y-1">
                    <p className="font-mono text-xs text-muted-foreground truncate" title={page.url}>
                      {page.url}
                    </p>
                    <div className="flex flex-wrap gap-1.5">
                      {page.values.map((v, i) => (
                        <Badge key={i} variant="secondary" className="font-normal text-xs">
                          {v}
                        </Badge>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
